import { render, staticRenderFns } from "./DialogAccount.vue?vue&type=template&id=f8530312"
import script from "./DialogAccount.vue?vue&type=script&lang=js"
export * from "./DialogAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports